import { useCallback, useRef } from "react"
import { useIsomorphicLayoutEffect } from "@/tiptap/hooks/use-isomorphic-layout-effect"

/**
 * Returns a stable function reference that always calls the latest version
 * of the provided callback. Useful for passing callbacks as props without
 * causing child re-renders, while avoiding stale-closure bugs.
 *
 * Based on the useEvent RFC pattern.
 */
export function useStableCallback(callback) {
  const callbackRef = useRef(callback)

  useIsomorphicLayoutEffect(() => {
    callbackRef.current = callback
  })

  return useCallback((...args) => callbackRef.current?.(...args), [])
}

export default useStableCallback
